import { firstValueFrom } from 'rxjs';
import {Injectable, Inject, PLATFORM_ID} from '@angular/core';
import { ApiService, IBakery, TransferableGetApiService } from '@cakeiteasy/web-utils';
import { TransferState } from '@angular/core';

@Injectable()
export class BakeriesApiService extends TransferableGetApiService {

  constructor(@Inject('AppConfig') appConfig: any,
              @Inject(PLATFORM_ID) _platformId: any,
              transferState: TransferState,
              api: ApiService) {
    super(api, appConfig, _platformId, transferState);
  }

  public getBakeriesByCityPostNumber(countryCode: string,
                                     postNumber: string,
                                     cityName = 'null'): Promise<any[]> {
    return firstValueFrom(this.api
      .get('api.bakery',
        'bakeries_by_city_post_number',
        { cityName }, {
          params: {
            countryCode,
            postNumber
          }
        }));
  }

  getBakeryById(bakeryId: any): Promise<IBakery> {
    return firstValueFrom(this.getWithCaching('api.bakery',
      'bakery_by_id',
      { id: bakeryId }));
  }

  getBakeryByRefName(refName: string, country?: string): Promise<IBakery> {
    return firstValueFrom(this.getWithCaching('api.bakery', 'bakery_by_name', { refName }, { params: { country } }));
  }

  getCountryBakeries(countryCode: string) {
    return firstValueFrom(this.getWithCaching('api.bakery',
      'bakeries',
      {}, { params: { countryCode } }));
  }

  getBakeriesByPlaceName(countryCode: string, query: string): Promise<IBakery[]> {
    return firstValueFrom(this.getWithCaching(
      'api.bakery',
      'bakeries_search',
      {}, { params: { countryCode, query, searchInPlaces: true } }));
  }

  getTermsAndConditions(bakeryId: number) {
    return firstValueFrom(this.getWithCaching('api.bakery', 'terms_and_conditions', { bakeryId }));
  }
}
